import { Link, useLocation } from "react-router-dom";
import { Sidebar, Menu, MenuItem } from "react-pro-sidebar";
import Cookies from "js-cookie";

const menuItems = [
  {
    title: "Orders",
    link: "/orders",
  },
  {
    title: "My Stock",
    link: "/my-stock",
  },
  {
    title: "Details",
    link: "/details",
  },
  {
    title: "Making Charges",
    link: "/making-charges",
  }
];

const conditionalItems = [
  {
    title: "My Store",
    link: "/my-store",
  },
  {
    title: "Store Link",
    link: "/store-link",
  },
];

const cookieData = Cookies.get("kalista-web-user");
const customerData = cookieData ? JSON.parse(cookieData) : null;

const DashboardSidebar = () => {
  const location = useLocation();
  const menuItemStyles = {
    root: {
      fontSize: "14px",
      fontWeight: 400,
    },
  };

  const showNavMenu = customerData?.IsAllowedStoreLink === true;

  return (
    <Sidebar
      rootStyles={{ color: "#607489" }}
      width={"230px"}
      className="dashboard_sidebar"
    >
      <Menu menuItemStyles={menuItemStyles} className="sidebar_menu_con">
        {menuItems.map((menu) => (
          <MenuItem
            key={menu.link}
            component={<Link to={menu.link} />}
            active={location.pathname === menu.link}
          >
            {menu.title}
          </MenuItem>
        ))}

        {showNavMenu &&
          conditionalItems.map((item) => (
            <MenuItem
              key={item.link}
              component={<Link to={item.link} />}
              active={location.pathname === item.link}
            >
              {item.title}
            </MenuItem>
          ))}
      </Menu>
    </Sidebar>
  );
};

export default DashboardSidebar;
